import BaseAPIService from '../base/base-api-service';
import ArSummaryModel from 'src/model/arSummary.model';
import env from 'src/shared/env';

class ArSummaryService extends BaseAPIService<ArSummaryModel> {
  public baseURL: string = env.REACT_APP_BASE_API_URL;
  public endpoint: string = 'accountapp/v1/arSummary';

  constructor() {
    super(ArSummaryModel);
  }

  public getArSummary() {
    const arSummaryEndpoint = `${this.baseURL}${this.endpoint}`;

    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'get',
        url: arSummaryEndpoint
      })
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
}

const arSummaryServiceInstance = new ArSummaryService();
Object.freeze(arSummaryServiceInstance);

export default arSummaryServiceInstance;
